(function () {
  "use strict";

  var ready = function (fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
      return;
    }
    fn();
  };

  ready(function () {
    var page = document.querySelector(".project-detail-page");
    if (!page) return;

    var progress = document.createElement("div");
    progress.className = "project-read-progress";
    progress.setAttribute("aria-hidden", "true");
    progress.innerHTML = "<span></span>";
    document.body.appendChild(progress);

    var progressBar = progress.querySelector("span");
    var updateProgress = function () {
      var scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
      var scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      progressBar.style.transform = "scaleX(" + Math.min(1, scrollTop / scrollable) + ")";
    };

    updateProgress();
    window.addEventListener("scroll", updateProgress, { passive: true });
    window.addEventListener("resize", updateProgress);

    var nav = document.querySelector(".project-console__nav");
    var navLinks = nav ? Array.from(nav.querySelectorAll("a[href^='#']")) : [];
    var sections = navLinks
      .map(function (link) {
        var id = decodeURIComponent(link.getAttribute("href").slice(1));
        var target = document.getElementById(id);
        return target ? { link: link, target: target } : null;
      })
      .filter(Boolean);

    if (sections.length && "IntersectionObserver" in window) {
      var activeId = "";
      var setActive = function (id) {
        if (activeId === id) return;
        activeId = id;
        sections.forEach(function (item) {
          var selected = item.target.id === id;
          item.link.classList.toggle("is-active", selected);
          if (selected) item.link.setAttribute("aria-current", "true");
          else item.link.removeAttribute("aria-current");
        });
      };

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) setActive(entry.target.id);
          });
        },
        { rootMargin: "-28% 0px -60% 0px", threshold: 0.01 }
      );

      sections.forEach(function (item) {
        observer.observe(item.target);
      });
    }

    if (navLinks.length) {
      navLinks.forEach(function (link) {
        link.addEventListener("click", function () {
          navLinks.forEach(function (item) {
            item.classList.remove("is-active");
            item.removeAttribute("aria-current");
          });
          link.classList.add("is-active");
          link.setAttribute("aria-current", "true");
        });
      });
    }

    document.querySelectorAll(".floor-cards.scroll-3, .floor-cards.scroll-2, .villa-cards.scroll-2").forEach(function (rail) {
      if (rail.scrollWidth <= rail.clientWidth + 8) return;
      rail.classList.add("has-scroll-hint");
      rail.setAttribute("tabindex", "0");
      rail.setAttribute("aria-label", rail.getAttribute("aria-label") || "Scrollable floor plan options");
    });

    document.querySelectorAll("[data-floor-selector]").forEach(function (selector) {
      var categoryButtons = Array.from(selector.querySelectorAll("[data-floor-category-button]"));
      var sizeGroups = Array.from(selector.querySelectorAll("[data-floor-size-group]"));
      var sizeButtons = Array.from(selector.querySelectorAll("[data-floor-plan-button]"));
      var cards = Array.from(selector.querySelectorAll("[data-floor-plan-card]"));

      var setActivePlan = function (planId) {
        if (!planId) return;
        sizeButtons.forEach(function (button) {
          var active = button.dataset.floorPlanButton === planId;
          button.classList.toggle("is-active", active);
          button.setAttribute("aria-pressed", active ? "true" : "false");
        });
        cards.forEach(function (card) {
          var active = card.dataset.floorPlanCard === planId;
          card.classList.toggle("is-active", active);
          card.hidden = !active;
        });
      };

      var setActiveCategory = function (categoryKey) {
        if (!categoryKey) return;
        categoryButtons.forEach(function (button) {
          var active = button.dataset.floorCategoryButton === categoryKey;
          button.classList.toggle("is-active", active);
          button.setAttribute("aria-pressed", active ? "true" : "false");
        });
        sizeGroups.forEach(function (group) {
          var active = group.dataset.floorSizeGroup === categoryKey;
          group.classList.toggle("is-active", active);
          group.hidden = !active;
          if (active) {
            var activeButton = group.querySelector("[data-floor-plan-button].is-active") || group.querySelector("[data-floor-plan-button]");
            group.scrollLeft = 0;
            if (activeButton) {
              setActivePlan(activeButton.dataset.floorPlanButton);
              activeButton.scrollIntoView({ block: "nearest", inline: "start" });
            }
          }
        });
      };

      categoryButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          setActiveCategory(button.dataset.floorCategoryButton);
        });
      });

      sizeButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          setActivePlan(button.dataset.floorPlanButton);
          button.scrollIntoView({ block: "nearest", inline: "center" });
        });
      });
    });

    var form = document.getElementById("lead-form");
    var formTitle = document.getElementById("project-inquiry-heading");
    if (form && formTitle) {
      var planRequestHighlightTimer = 0;
      var indicatePlanRequestForm = function () {
        var sidePanel = form.closest(".project-inquiry-side");
        var target = sidePanel || form;
        if (sidePanel) {
          sidePanel.classList.remove("is-plan-request-highlight");
          void sidePanel.offsetWidth;
          sidePanel.classList.add("is-plan-request-highlight", "is-engaged");
          window.clearTimeout(planRequestHighlightTimer);
          planRequestHighlightTimer = window.setTimeout(function () {
            sidePanel.classList.remove("is-plan-request-highlight");
          }, 1800);
        }
        target.scrollIntoView({ behavior: "smooth", block: "center" });
        window.setTimeout(function () {
          var firstField = form.querySelector("input:not([type='hidden']), textarea, select, button");
          if (firstField && typeof firstField.focus === "function") {
            firstField.focus({ preventScroll: true });
          }
        }, 420);
      };

      document.querySelectorAll(".floor-plan-feature-cta[href='#lead-form']").forEach(function (button) {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          indicatePlanRequestForm();
        });
      });

      form.addEventListener("focusin", function () {
        form.closest(".project-inquiry-side")?.classList.add("is-engaged");
      });
      form.addEventListener("focusout", function () {
        window.setTimeout(function () {
          if (!form.contains(document.activeElement)) {
            form.closest(".project-inquiry-side")?.classList.remove("is-engaged");
          }
        }, 60);
      });
    }

    // "Request floor plan" from an email (?open=floor-plan): only the enquiry form until it is sent (owner, 2026-10-02).
    var gate = document.getElementById("plan-gate");
    var gateSlot = gate ? gate.querySelector("[data-plan-gate-slot]") : null;
    if (gate && gateSlot && form) {
      var home = form.parentNode;
      var homeNext = form.nextSibling;
      gateSlot.appendChild(form);
      window.setTimeout(function () {
        var nameField = form.querySelector("input[name='name']");
        if (nameField && typeof nameField.focus === "function") nameField.focus({ preventScroll: true });
      }, 120);

      var liftGate = function () {
        home.insertBefore(form, homeNext);
        gate.remove();
        document.body.classList.remove("has-plan-gate");
        try {
          var url = new URL(window.location.href);
          url.searchParams.delete("open");
          url.searchParams.delete("plan");
          window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
        } catch (error) {
          // Old browser: the page simply keeps its address.
        }
        window.scrollTo(0, 0);
      };

      window.addEventListener("g3:lead-submitted", function () {
        var thanks = gate.querySelector("[data-plan-gate-thanks]");
        gateSlot.hidden = true;
        if (thanks) thanks.hidden = false;
        window.setTimeout(liftGate, 1600);
      }, { once: true });
    }
  });
})();
